<template>
    <v-card>
        <v-card-title>
            <v-btn icon small @click="close" color="primary">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3 class="ml-2">Reasons for cancellation of deliveries</h3>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-0"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
            >
                <template v-slot:[`item.date`]="{ item }">
                    <p class="my-0 ">{{ formatDate(item.rejectedOn) }}</p>
                </template>
                <template v-slot:[`item.user`]="{ item }">
                    <p class="my-0 ">{{ getUserName(item) }}</p>
                </template>
                <template v-slot:[`item.rejectedQty`]="{ item }">
                    <p class="my-0 d-flex justify-end mx-1">
                        {{ item.rejectedQty }}
                    </p>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'

export default {
    name: 'RejectionStockItemsTable',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
        users: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data: () => ({
        headers: [
            {
                text: 'DATE',
                value: 'date',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'USER',
                value: 'user',
                align: 'center',
                sortable: false,
                width: '200',
            },
            {
                text: 'QUANTITY',
                value: 'rejectedQty',
                align: 'rigth',
                width: '120',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
        ],
    }),
    methods: {
        formatDate(date) {
            return moment
                .unix(date.seconds || date._seconds)
                .format('YYYY-MM-DD')
        },
        close() {
            this.$emit('closeDialog')
        },
        getUserName(item) {
            let userName = ''
            const user = this.users.find(u => u.id == item.rejectedBy)
            if (user) {
                userName = user.name
            }
            return userName
        },
    },
}
</script>

<style></style>
